import { createSelector } from '@reduxjs/toolkit';

/**
 * Generic factory for creating filtered list selectors
 * Eliminates duplication of search filtering logic across components
 */
export const createFilteredListSelector = <T>(
    listSelector: (state: any) => T[],
    filterFn: (items: T[], searchTerm: string) => T[]
) => {
    return createSelector(
        [listSelector, (state: any, searchTerm: string) => searchTerm],
        (items, searchTerm) => {
            if (!searchTerm) return items;
            return filterFn(items, searchTerm);
        }
    );
};

/**
 * Generic text search filter function
 * Searches in a specified field of the item
 */
export const createTextSearchFilter = <T>(fieldGetter: (item: T) => string) => {
    return (items: T[], searchTerm: string): T[] => {
        return items.filter(item => 
            fieldGetter(item).toLowerCase().includes(searchTerm.toLowerCase())
        );
    };
};

/**
 * Factory for creating sorted list selectors
 */
export const createSortedListSelector = <T>(
    listSelector: (state: any) => T[],
    sortFn: (a: T, b: T) => number
) => {
    return createSelector(
        [listSelector],
        (items) => [...items].sort(sortFn)
    );
};